import {CreateSharedProductsLinkWs} from './ws/create-share-products-link-ws';
import {Injectable} from "@angular/core";
import {environment} from "src/environments/environment";
import {CreateShareProductsLinkService} from "@app/core/product/domain/services/create-share-products-link.service";
import {catchError, Observable} from "rxjs";
import {routesNames} from "@app/app-routing.module";
import {BaseHandleErrorMapper} from '@app/core/shared/infrastructure/base.handler/base-handle-error.mapper';


@Injectable()
export class CreateShareProductsLinkDataService implements CreateShareProductsLinkService {

    private readonly HOSTNAME = environment.BASE_URL;

    constructor(
        private createSharedProductsLinkWs: CreateSharedProductsLinkWs,
    ) {}

    execute(productCodes: string[]): Observable<string> {
        const productCodesString = productCodes.join(',');
        const link = `${this.HOSTNAME}/${routesNames.shared}?products=${productCodesString}`;
        return this.createSharedProductsLinkWs.execute(link).pipe(
            catchError(error => BaseHandleErrorMapper.handleError(error)),
        );
    }
}